import { Autocomplete, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import {
  InstantSearch,
  useHits,
  useSearchBox,
} from "react-instantsearch-hooks-web";
import createTypesenseISAdapter from "../config/typesense";
import InputCustom from "./InputCustom";

const transformItems = (items, { results }) => {
  return items.map(({ objectID, id, name }) => ({
    objectID,
    id,
    name,
  }));
};

function CustomSearch({
  value,
  onChange,
  inputCustomProps,
  switchProps,
  ...restProps
}) {
  const [inputValue, setInputValue] = useState("");
  const { refine } = useSearchBox();
  const { hits } = useHits({ transformItems });
  return (
    <Autocomplete
      options={hits}
      filterOptions={(x) => x}
      autoComplete
      includeInputInList
      disableClearable
      freeSolo
      value={value}
      onChange={(e, newValue) => {
        if (typeof newValue === 'string') {
          onChange({
            name: newValue
          })
        } else {
          onChange(newValue);
        }
      }}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => {
        onChange({
          name: newInputValue
        });
        setInputValue(newInputValue);
        refine(newInputValue);
      }}
      isOptionEqualToValue={(option, value) =>
        option.objectID === value.objectID
      }
      renderInput={(params) => {
        return (
          <InputCustom
            containerRef={params.InputProps.ref}
            placeholder="Sarjana Ilmu Komputer"
            title="Apakah Gelar atau kualifikasi anda?"
            inputProps={params.inputProps}
            {...inputCustomProps}
          />
        );
      }}
      getOptionLabel={(option) => option.name ?? ""}
      renderOption={(props, option, state) => {
        return (
          <li {...props} key={option.objectID}>
            <Typography
              sx={
                !state.selected
                  ? { fontFamily: "glacial_indifferenceregular" }
                  : {}
              }
            >
              {option.name}
            </Typography>
          </li>
        );
      }}
      {...restProps}
    />
  );
}

export default function InputDegreeSearch({ onChange, value, lang, level, ...restProps }) {


  const typsesenseAdapter = useMemo(() => createTypesenseISAdapter({
    query_by: "name",
    typo_tokens_threshold: 3,
    filter_by: `lang:=${lang} && level:=${level}`
  }), [lang, level]);


  const searchClient = typsesenseAdapter.searchClient;
  return (
    <InstantSearch indexName="degree" searchClient={searchClient}>
      <CustomSearch onChange={onChange} value={value} {...restProps} />
    </InstantSearch>
  );
}
